import axios from "axios";

const LOCALHOST_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export function resolveBackendUrl(configuredUrl, browserHostname) {
  const fallbackUrl = "/api";
  if (!configuredUrl) return fallbackUrl;

  try {
    const parsed = new URL(configuredUrl);
    const browserHost = browserHostname ?? (typeof window !== "undefined" ? window.location.hostname : "");
    const isBrowserOnLocalhost = LOCALHOST_HOSTS.has(browserHost);
    const isConfiguredLocalhost = LOCALHOST_HOSTS.has(parsed.hostname);

    if (isConfiguredLocalhost && !isBrowserOnLocalhost) {
      return fallbackUrl;
    }
  } catch (_) {
    // Relative paths such as /api are valid axios base URLs.
  }

  return configuredUrl;
}

export const BACKEND_URL = resolveBackendUrl(process.env.REACT_APP_BACKEND_URL);
export const API = BACKEND_URL;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ls_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("ls_token");
    }
    return Promise.reject(err);
  }
);
